import { createContext, useContext } from 'react';

/**
 * Opt-in "record" look for the shared wealth screen (investor portal rework,
 * ENG-3507). Add this class next to `wealth-container` and import
 * `@wavvest/wealth-ui/record-style.scss` to restyle the shared cards and data
 * tables; screens without the class keep the current look.
 */
export const WEALTH_RECORD_STYLE_CLASS = 'wealth-ui-record';

const RecordStyleContext = createContext(false);

/**
 * Tells shared pieces rendered outside the container (the purchase-lots
 * drawer, portalled to <body>) to use the record look as well.
 */
export const WealthRecordStyleProvider = RecordStyleContext.Provider;

export const useWealthRecordStyle = () => useContext(RecordStyleContext);
